import { Divider } from "antd";

const Gamunex = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">
          Important Safety Information
        </p>

        <p className="m-2">
          GAMUNEX®-C (immune globulin injection [human], 10% caprylate/chromatography purified) is indicated
          for the treatment of primary humoral immunodeficiency disease (PIDD) in
          patients 2 years of age and older, idiopathic thrombocytopenic purpura
          (ITP) in adults and children, and chronic inflammatory demyelinating
          polyneuropathy (CIDP) in adults.
        </p>

        <p className="m-2 font-bold">
          Thrombosis may occur with immune globulin products, including GAMUNEX-C. Risk factors may include: advanced
          age, prolonged immobilization, hypercoagulable conditions, history of venous or arterial thrombosis, use of
          estrogens, indwelling central vascular catheters, hyperviscosity, and cardiovascular risk factors. Thrombosis
          may occur in the absence of known risk factors. For patients at risk of thrombosis, administer GAMUNEX-C at
          the minimum dose and infusion rate practicable. Ensure adequate hydration in patients before administration.
          Monitor for signs and symptoms of thrombosis and assess blood viscosity in patients at risk for
          hyperviscosity.
        </p>

        <p className="m-2 font-bold">
          Renal dysfunction, acute renal failure, osmotic nephrosis, and death may occur with immune globulin
          intravenous (IVIG) products in predisposed patients. Patients predisposed to renal dysfunction include those
          with any degree of preexisting renal insufficiency, diabetes mellitus, age greater than 65, volume depletion,
          sepsis, paraproteinemia, or patients receiving known nephrotoxic drugs. Renal dysfunction and acute renal
          failure occur more commonly in patients receiving IVIG products containing sucrose. GAMUNEX-C does not contain
          sucrose. For patients at risk of renal dysfunction or failure, administer GAMUNEX-C at the minimum
          concentration available and the minimum infusion rate practicable.
        </p>

        <p className="m-2">
          GAMUNEX-C is contraindicated in patients who have had an anaphylactic or severe systemic reaction to the
          administration of human immune globulin. It is contraindicated in IgA-deficient patients with antibodies
          against IgA and history of hypersensitivity.
        </p>

        <p className="m-2">
          GAMUNEX-C is contraindicated in patients who have had an anaphylactic or severe systemic reaction to the
          administration of human immune globulin. It is contraindicated in IgA-deficient patients with antibodies
          against IgA and history of hypersensitivity.
        </p>

        <p className="m-2">
          Severe hypersensitivity reactions may occur with IVIG products, including GAMUNEX-C. In case of
          hypersensitivity, discontinue GAMUNEX-C infusion immediately and institute appropriate treatment.
        </p>

        <p className="m-2">
          Monitor renal function, including blood urea nitrogen (BUN), serum creatinine, and urine output in patients at
          risk of developing acute renal failure.
        </p>

        <p className="m-2">
          Hyperproteinemia, increased serum viscosity, and hyponatremia may occur in patients receiving IVIG treatment,
          including GAMUNEX-C.
        </p>

        <p className="m-2">
          There have been reports of aseptic meningitis, hemolytic anemia, and noncardiogenic pulmonary edema
          (transfusion-related acute lung injury [TRALI]) in patients administered with IVIG, including GAMUNEX-C.
        </p>

        <p className="m-2">
          The high-dose regimen (1g/kg x 1-2 days) is not recommended for individuals with expanded fluid volumes or
          where fluid volume may be a concern.
        </p>

        <p className="m-2">
          Because GAMUNEX-C is made from human blood, it may carry a risk of transmitting infectious agents, eg,
          viruses, and, theoretically, the Creutzfeldt-Jakob disease (CJD) agent.
        </p>

        <p className="m-2">
          Do not administer GAMUNEX-C subcutaneously in patients with ITP because of the risk of hematoma formation.
        </p>

        <p className="m-2">
          Periodic monitoring of renal function and urine output is particularly important in patients judged to be at
          increased risk of developing acute renal failure. Assess renal function, including measurement of BUN and
          serum creatinine, before the initial infusion of GAMUNEX-C and at appropriate intervals thereafter.
        </p>

        <p className="m-2">
          Consider baseline assessment of blood viscosity in patients at risk for hyperviscosity, including those with
          cryoglobulins, fasting chylomicronemia/markedly high triacylglycerols (triglycerides), or monoclonal
          gammopathies, because of the potentially increased risk of thrombosis.
        </p>

        <p className="m-2">
          If signs and/or symptoms of hemolysis are present after an infusion of GAMUNEX-C, perform appropriate
          laboratory testing for confirmation.
        </p>

        <p className="m-2">
          If TRALI is suspected, perform appropriate tests for the presence of antineutrophil antibodies and anti-HLA
          antibodies in both the product and patient’s serum.
        </p>

        <p className="m-2">
          After infusion of IgG, the transitory rise of the various passively transferred antibodies in the patient’s
          blood may yield positive serological testing results, with the potential for misleading interpretation.
        </p>

        <p className="m-2">
          In clinical studies, the most common adverse reactions with GAMUNEX-C were headache, pyrexia, hypertension,
          chills, rash, nausea, arthralgia, and asthenia (in CIDP); cough, rhinitis, pharyngitis, headache, asthma,
          nausea, fever, diarrhea, and sinusitis with intravenous use (in PIDD) and local infusion-site reactions,
          fatigue, headache, upper respiratory tract infection, arthralgia, diarrhea, nausea, sinusitis, bronchitis,
          depression, allergic dermatitis, migraine, myalgia, viral infection, and pyrexia with subcutaneous use (in
          PIDD); and headache, ecchymosis, vomiting, fever, nausea, rash, abdominal pain, back pain, and dyspepsia (in
          ITP).
        </p>

        <p className="m-2">
          The most serious adverse reactions in clinical studies were pulmonary embolism (PE) in 1 subject with a
          history of PE (in CIDP), an exacerbation of autoimmune pure red cell aplasia in 1 subject (in PIDD), and
          myocarditis in 1 subject that occurred 50 days post-study drug infusion and was not considered drug related
          (in ITP).
        </p>

        <div>
          <p className="m-2">
            <b>
              Please see
              <a
                target="_blank"
                href="/Gamunex-Prescribing-Information.pdf"
                className="text-blue-500"
              >
                &nbsp; GAMUNEX-C full Prescribing Information&nbsp;
              </a>
              for complete prescribing details.
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of
              prescription drugs to the FDA. Visit
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500"
              >
                &nbsp;www.fda.gov/medwatch&nbsp;
              </a>
              or call 1-800-FDA-1088.
            </b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Gamunex;
